// 角色管理
import http from "@/jslibs/axios/http";

// 新增角色
export const add = (data) => http.post("/cms/role/add", data);

// 编辑角色
export const edit = (data) => http.post("/cms/role/update", data);

// 角色详情
export const detail = (id) => http.get("/cms/role/details/" + id);

// 角色全量列表
export const list = () => http.get("/cms/role/list");

// 角色分页列表
export const page = (data) => http.get("/cms/role/page", data);

// 角色删除
export const del = (id) => http.delete("/cms/role/" + id);
